import React from 'react';

import { Theme, useTheme } from '@mui/material';
import { LexicalEditor } from 'lexical';
import {
  INSERT_ORDERED_LIST_COMMAND,
  INSERT_UNORDERED_LIST_COMMAND,
  REMOVE_LIST_COMMAND,
} from '@lexical/list';

import { MenuItem } from '../../../../../MenuItem';
import { Box } from '../../../../../Box';
import { Typography } from '../../../../../Typography';
import { Icon } from '../../../../../Icon';

export type BlockListTypeToBlockName = {
  bullet: string;
  number: string;
  paragraph: string;
};

export const blockListTypeToBlockName: BlockListTypeToBlockName = {
  bullet: 'Маркированный список',
  number: 'Нумерованный список',
  paragraph: '',
};

export type ListTypeKeys = keyof BlockListTypeToBlockName;

export const getListIcon = (
  listType: string,
  theme: Theme,
  activeList?: ListTypeKeys,
) => {
  const getColor = (item: string, activeItem?: string) =>
    item === activeItem ? 'original.brand.primary' : 'text.light.primary';

  switch (listType) {
    case 'bullet':
      return (
        <Icon
          name="list_outline"
          size="20"
          color={getColor('bullet', activeList)}
        />
      );
    case 'number':
      return (
        <Icon
          name="list_number_outline"
          size="20"
          color={getColor('number', activeList)}
        />
      );
    default:
      return <Icon name="list_outline" size="20" color="text.light.primary" />;
  }
};

export const useList = (editor: LexicalEditor, blockListType: ListTypeKeys) => {
  const theme = useTheme();

  const handleListFormat = (listType: string) => {
    if (listType === 'bullet' && blockListType !== 'bullet') {
      editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, undefined);

      return;
    }
    if (listType === 'number' && blockListType !== 'number') {
      editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, undefined);

      return;
    }

    editor.dispatchCommand(REMOVE_LIST_COMMAND, undefined);
  };

  return [
    Object.entries(blockListTypeToBlockName).map(([listType, name]) => {
      if (listType === 'paragraph') {
        return null;
      }

      return (
        <MenuItem onClick={() => handleListFormat(listType)} key={listType}>
          <Box display="flex" alignItems="center" gap="8">
            {getListIcon(listType, theme, blockListType)}
            <Typography
              variant="body3"
              color={
                blockListType === listType
                  ? 'original.brand.primary'
                  : 'text.light.primary'
              }
            >
              {name}
            </Typography>
          </Box>
        </MenuItem>
      );
    }),
    getListIcon(blockListType, theme),
  ];
};
